import SEO from '../components/SEO';

export default function About() {
  return (
    <div className="page container">
      <SEO
        title="About Joan Christine Nyawira | Physiotherapist & Digital Marketer"
        description="Meet Joan Christine Nyawira — a Kenya-based physiotherapist, digital marketer, and academic writer sharing knowledge through health, marketing, and content."
        path="/about"
      />
      <div className="glass-card" style={{ maxWidth: 720, margin: '0 auto' }}>
        <h1>About Me</h1>
        <p>
          Hi! I'm <strong>Joan Christine Nyawira</strong>, a passionate physiotherapist based in Kenya,
          graduated in December 2025. I also have hands-on experience in digital marketing, specializing
          in SEO, analytics, email marketing, and search ads.
        </p>
        <p style={{ marginTop: '1.25rem' }}>
          As an academic writer and dedicated blogger, I love sharing knowledge and helping others achieve
          their best — whether it's through health, marketing, or insightful content. Welcome to my world
          of healing, creativity, and growth!
        </p>
      </div>
    </div>
  );
}
